import { Select } from '@chakra-ui/react';

const CustomSelect = ({ name, options, defaultValue, ...props }) => {
    return (
        <Select {...props} value={defaultValue}>
            {options.map((item) => (
                <option key={item.id ?? item.value ?? item.label ?? item?.contact_name} value={JSON.stringify(item)}  >{item.label || item?.contact_name}</option>
            ))}
        </Select>
    );
};

export default CustomSelect;
 